import styled from "styled-components";
import { Form as Unform } from "@unform/web";
import cover from "../../Assets/cover.png";

export const Container = styled.div`
  display: flex;
  max-width: 1800px;
  margin: 0 auto;
`;

export const Cover = styled.div`
  background: url(${cover});
  background-size: contain;
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100vh;
  border-right: 2px solid #eee;
  width: 100%;
  height: 100vh;
  background-color: #f4f4f4;
  @media only screen and (max-width: 425px) {
    height: 0px;
    width: 0px;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  & > * {
    margin-bottom: 20px;
  }
  & button {
    background: #2dad67;
    border-radius: 50px;
    text-transform: uppercase;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 1px;
    color: white;
    width: 100%;
  }
`;

export const InputGroup = styled.div`
  width: 100%;
  & label {
    color: #373737;
  }
  & input {
    background: #e1e1e1;
    border-radius: 10px;
    border: none;
  }
  & select {
    width: 100%;
    padding: 10px;
    border-radius: 10px;
    background: #e1e1e1;
    border: none;
  }
  & option {
  }
`;

export const Title = styled.h1`
  color: #373737;
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  margin-bottom: 50px;
`;

export const Step = styled.div`
  width: 80%;
  margin: 0 auto;
  margin-top: 40px;
`;
